/* Only badge visibility changes. Events are scoped to the existing product section. */
(function () {
  'use strict';
  function roots(section) { return section.querySelectorAll('[data-pt-native-badges]'); }
  function show(section, id) {
    roots(section).forEach(function (root) {
      root.querySelectorAll('[data-pt-badge-variant]').forEach(function (panel) {
        panel.hidden = id == null || panel.dataset.ptBadgeVariant !== String(id);
      });
    });
  }
  function initialise(scope) {
    scope.querySelectorAll('[data-section-type="product-template"]').forEach(function (section) {
      var select = section.querySelector('select[name="id"]');
      if (select && roots(section).length) show(section, select.value || null);
    });
  }
  document.addEventListener('pt:badge-variant-change', function (event) {
    if (event.target instanceof Element && event.target.matches('[data-section-type="product-template"]')) {
      show(event.target, event.detail ? event.detail.variantId : null);
    }
  });
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!(target instanceof Element) || !target.matches('select[name="id"]')) return;
    var section = target.closest('[data-section-type="product-template"]');
    if (section) show(section, target.value || null);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initialise(document); });
  else initialise(document);
  document.addEventListener('shopify:section:load', function (event) {
    initialise(event.target.parentElement || document);
  });
}());
